import { render, staticRenderFns } from "./SettingButtons.vue?vue&type=template&id=2552cab8&scoped=true"
import script from "./SettingButtons.vue?vue&type=script&lang=js"
export * from "./SettingButtons.vue?vue&type=script&lang=js"
import style0 from "./SettingButtons.vue?vue&type=style&index=0&id=2552cab8&prod&lang=css"
import style1 from "./SettingButtons.vue?vue&type=style&index=1&id=2552cab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552cab8",
  null
  
)

export default component.exports